import { createReducer } from "@/redux/helpers/reducer";

import * as actions from "./alerts.actions";
import { ALERT_VARIANT, REPLACING_UNDO_KINDS } from "./constants";

const initialState = { alerts: [] };

export default createReducer(initialState, {
  // `undoKind` names which restore to run and `undo` is that restore's descriptor - both plain data,
  // not callbacks, so the slice stays serializable.
  // A repeated DANGER alert replaces the one already showing instead of stacking: danger alerts
  // never auto-dismiss (PlannerAlerts sets autoDismiss={!isDanger}), so retrying a failing action
  // piled up identical red toasts.
  //
  // Success alerts must keep stacking. Every delete uses the same "Event deleted" text but carries
  // its own undo target, so deduping them by message would silently drop the Undo for the event
  // deleted first. They also expire on their own, so they never pile up.
  //
  // The exception is REPLACING_UNDO_KINDS: those toasts replace the previous toast of the same kind.
  [actions.addAlert]: (state, { id, message, variant, undo, undoKind }) => {
    const replacesExisting = (alert) =>
      (variant === ALERT_VARIANT.DANGER &&
        alert.variant === ALERT_VARIANT.DANGER &&
        alert.message === message) ||
      (REPLACING_UNDO_KINDS.includes(undoKind) && alert.undoKind === undoKind);

    return {
      alerts: [
        ...state.alerts.filter((alert) => !replacesExisting(alert)),
        { id, message, variant, undo, undoKind },
      ],
    };
  },
  [actions.dismissAlert]: (state, { id }) => ({
    alerts: state.alerts.filter((alert) => alert.id !== id),
  }),
});
